import { render, staticRenderFns } from "./ViewRecommendation.vue?vue&type=template&id=1e7b4ce6"
import script from "./ViewRecommendation.vue?vue&type=script&lang=js"
export * from "./ViewRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ViewRecommendation.vue?vue&type=style&index=0&id=1e7b4ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports